import { render, staticRenderFns } from "./ImageUploadView.vue?vue&type=template&id=48287430&scoped=true&"
import script from "./ImageUploadView.vue?vue&type=script&lang=js&"
export * from "./ImageUploadView.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadView.vue?vue&type=style&index=0&id=48287430&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48287430",
  null
  
)

export default component.exports